import React, { useContext, useEffect, useState } from "react";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { PlaceText } from "../genericPages/components/PlaceText";
import { getApiFromModule } from "../genericPages/helpers/GetContentsByModule";
import { FlatList, Image, Pressable, ScrollView, Share, StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";
import { IconShadow } from "../genericPages/helpers/DefaultShadows";
import { BasePage } from "../genericPages/helpers/BasePage";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import { getFeaturedImageUrl, makeMuseumDaysString, makeMuseumHourDateString, makeStartTimeString } from "../genericPages/helpers/DetailsHelpers";
import { BottomNavigationPadding } from "../genericPages/components/FindifyNavigation";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";



export const SchedulePage = ({ navigation }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [scheduleMenuItem, setScheduleMenuItem] = useState<any>({});
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);
    const [events, setEvents] = useState<any[]>([]);
    const insets = useSafeAreaInsets();
    const { t } = useTranslation();

    useEffect(() => {
        const menuItem = (findifyDataContext?.workspace?.app_settings?.app_menu_lines ?? []).find((m: any) => m.module === 'schedule' && m.type === 'module');
        setScheduleMenuItem(menuItem);

        getApiFromModule('events', findifyDataContext)?.getList(0, 10, null, { published_eq: 1 }, { orderby: JSON.stringify({ start_date: "ASC" }) }).then((res) => {
            const evs = res.results;
            setEvents(evs);
        });

        setActionsList([{
            icon: 'share-outline',
            action: async () => {
                const result = await Share.share({
                    title: t('modules.content_types.events') + ' - ' + getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                    message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}&type=list&module=events`,
                }, {
                    dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                });
            }
        }]);
    }, [])


    return <BasePage navigation={navigation}>
        {/* <FindifyTopBarOverlay /> */}
        <FlatList
            key={'eventsListAgenda'}
            data={events.map((event: any) => {
                const dateStart = new Date(event?.start_date);
                const dateEnd = new Date(event?.end_date);
                const dateString = makeStartTimeString(dateStart) + ' - ' + makeStartTimeString(dateEnd);


                return {
                    ...event,
                    hours_string: makeMuseumHourDateString(dateStart, dateEnd),
                    days_string: makeMuseumDaysString(dateStart, dateEnd),
                    id: event.event_id,
                    title: event.name,
                    image: getFeaturedImageUrl(event),
                    date: dateString,
                    onPress: () => {
                        navigation.push('PlaceContentDetails', {
                            module: 'events',
                            event_id: event.event_id,
                            page_slug: event.page_slug
                        })
                    }
                }
            })}
            numColumns={1}
            ListHeaderComponent={() => <View style={{
                marginBottom: 10,
            }}>
                <FindifySimpleHeader
                    isEventLayout
                    navigation={navigation}
                    title={scheduleMenuItem ? getTranslatedString(scheduleMenuItem.label, findifyDataContext) : t('modules.schedule')}
                    actions={actionsList}
                />
            </View>}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item, index }) => {
                return MuseumEventLine(item, index, findifyDataContext);
            }}
            bounces={false}
            keyExtractor={(item, index) => index.toString()}
            contentContainerStyle={[{
                paddingBottom: insets.bottom + BottomNavigationPadding,
            }]}
        />
    </BasePage>
};



const MuseumEventLine = (item: any, index: number, findifyDataContext: FindifyDataContextType) => {
    return <Pressable
        style={{
            marginHorizontal: 10,
            display: 'flex',
            flexDirection: 'row',
            gap: 10
        }}
        onPress={() => {
            item.onPress();
        }}
    >
        <Image source={{ uri: item.image }} style={{ width: 100, height: 100 }} />
        <View
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 0,
            }}
        >
            <View>
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).primary.get(),
                }}>{item.hours_string}</PlaceText>
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).primary.get(),
                }}>{item.days_string}</PlaceText>
            </View>
            <View>
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).primary.get(),
                    marginTop: 2,
                    fontWeight: 'bold',
                }}>{getTranslatedString(item.title, findifyDataContext)}</PlaceText>
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).primary.get(),
                }}>{getTranslatedString(item.resume, findifyDataContext)}</PlaceText>
            </View>
        </View>
    </Pressable>
}

const styles = StyleSheet.create({
    topNav: {},
    dateZone: {
        width: '100%',
        marginBottom: 10,

    },
    bottomBox: {
        flex: 1,
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
